import { useCurrentUser } from "../../hooks/useCurrentUser";
import React, { useEffect, useState } from "react";
import {
  FormControl,
  MenuItem,
  Box,
  Select,
  IconButton,
  Tooltip,
  Autocomplete,
  TextField,
  Checkbox,
  Typography,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Menu,
  Popover,
  Modal,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import { SlOptions } from "react-icons/sl";
import { Offcanvas } from "react-bootstrap";
import RichText from "../../components/common/RichText";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { DataGrid } from "@mui/x-data-grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import { toast } from "react-toastify";
import { createEntity, filterEntities } from "../../apis/apiService";
import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";
import SearchBar, { useDebounce } from "../../components/SearchBar";
import { useTheme } from "../../ThemeContext";
import { useFetchAllDepartmentsQuery, useFetchOTReportsQuery,} from "../../slice/logdetailSlice";
import Loader from "../../components/common/Loader";
import { OTReportCalender } from "./OTReportCalendar";
import OTReportsDetail from "./OTReportsDetail";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "../../App.css";


const getLast7Years = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 7 }, (_, i) => currentYear - i);
};

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const OTRepotrs = () => {
  const [openFilter, setOpenFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const { isDarkMode } = useTheme();
  const [selectedProjectId, setSelectedProjectId] = useState(0);
  const [filter, setFilter] = useState("approved_hours");
  // const [expandedGroups, setExpandedGroups] = useState({});
  const [checkedRows, setCheckedRows] = useState({});
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [anchorDateEl, setDateAnchorEl] = useState({
    anchorEl: null,
    rowId: null,
  });
  const [paginationModel, setPaginationModal] = useState({
    page: 0,
    pageSize: 25,
  });
  const [open, setOpen] = useState(false);
  const [selectedChildren, setSelectedChildren] = useState([]);
  const [usersCount, setusersCount] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("Pending");
  const [infoPanelOpen, setInfoPanelOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [paidDate, setPaidDate] = useState(null);

  const menuOpen = Boolean(anchorEl);
  const currentDate = new Date();
  const [selectedMonth, setSelectedMonth] = useState(
    currentDate.getMonth() + 1
  );
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [projectSpan, setProjectSpan] = useState("day");
  const [staffDetails, setStaffDetails] = useState([]);
  const [collectionOfDatas, setCollectionOfDatas] = useState([]);
  const { role: login_user_role } = useCurrentUser();
  const {
    data: ot_datas,
    refetch: ot_data_refetch,
    isLoading: ot_datas_loading,
  } = useFetchOTReportsQuery({
    department_id: selectedProjectId,
    month: selectedMonth,
    year: selectedYear,
    search: debouncedSearchTerm,
    isExport: 0,
  });

  const { data: get_all_departments = [], refetch: departmet_refetch } =
    useFetchAllDepartmentsQuery();
  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
  };
  const filterOptions = [
    { label: "Approved Hours", value: "approved_hours" },
    { label: "Pending Hours", value: "pending_hours" },
  ];
  const handleFilterChange = (event) => {
    const value = event.target.value;
    setFilter(value);
  };
  // useEffect(() => {
  //   console.log("filter_value :", filter);
  // }, [filter]);
  useEffect(() => {
    if (ot_datas) {
      setCollectionOfDatas(ot_datas?.records);
      setusersCount(ot_datas?.records?.length || 0);
    }
  }, [selectedProjectId, ot_datas]);

  useEffect(() => {
    ot_data_refetch();
    departmet_refetch();
  }, []);
  const handleNotesClick = (row) => {
    setSelectedRow(row);
    setNoteText(row.notes || "");
    setNoteModalOpen(true);
  };
  const handleNotesClicks = (row) => {
    setSelectedRow(row);
    setNoteText(row.notes || "");
    setNoteModalOpen(true);
  };
  const handleSaveNote = async () => {
    if (!selectedRow) return;
    // console.log("selected_row :", selectedRow);

    const updatedRow = {
      ...selectedRow,
      notes: noteText,
    };
    try {
      await updateApprovalStatus(
        updatedRow,
        selectedRow.payment_status,
        selectedRow.paid_date
      );

      toast.success("Notes updated successfully");
      setNoteModalOpen(false);
    } catch (err) {
      toast.error(err.message);
    }
  };
  const getStatusStyle = (status) => {
    const statusStyles = {
      PAID: {
        backgroundColor: "#d1ecf1",
        color: "#0c5460",
        borderColor: "#bee5eb",
      },
      PENDING: {
        backgroundColor: "#e2d6f6",
        color: "#6f42c1",
        borderColor: "#c8b6e2",
      },
      REJECTED: {
        backgroundColor: "#f8d7da",
        color: "#a31616",
        borderColor: "#f5c6cb",
      },
    };
    return (
      statusStyles[status] || {
        backgroundColor: "#fff",
        color: "#000",
        borderColor: "#ccc",
      }
    );
  };
  const convertTo12HourFormat = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const convertedHours = hours % 12 || 12; // Convert 0 or 12 to 12 for AM/PM format
    return `${convertedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };
  const handleUserClick = (row) => {
    setOpen(true);
    setSelectedRow(row);
  };

  const buildStaffDetails = (row, filter) => {
    if (!row) return [];

    if (filter === "approved_hours") {
      return (
        row.approved_log_details?.map((log, index) => ({
          id: log.time_logs_id,
          index: index + 1,
          log_date: log.log_date,
          user_name: row.user_name,
          task_title: log.task_title || log.general_log_name || log.title,
          hours: log.hours,
          hours_in_decimal: log.hours_in_decimal,
          start_time: log.start_time,
          end_time: log.end_time,
          approved_amount: log.amount,
          paid_date: row.paid_date,
          approved_status: log.approved_status,
          project_title: log.project_title,
          approved_by: log.approved_by,
          notes: log.notes,
        })) || []
      );
    }

    return (
      row?.pending_project_details?.pending_projects?.map((log, index) => ({
        id: log.time_logs_id,
        index: index + 1,
        log_date: log.log_date,
        task_title: log.task_title || log.general_log_name || log.title,
        hours: log.total_hours,
        hours_in_decimal: log.hours_in_decimal,
        start_time: log.start_time,
        end_time: log.end_time,
        approved_amount: log.amount,
        approved_status: log.approval_status,
        project_title: log.project_title,
        approved_by: log.approved_by,
        notes: log.notes,
      })) || []
    );
  };
  useEffect(() => {
    if (selectedRow) {
      const details = buildStaffDetails(selectedRow, filter);
      setStaffDetails(details);
    }
  }, [filter, selectedRow]);

  const handleToggleOpen = () => {
    setOpen(!open);
  };
  const renderStatusCell = (params) => {
    const row = params.row;

    if (row.isGroup) return null;

    const statusValue = row.payment_status;
    const dateValue = row.paid_date;

    // ✅ Disable dropdown if paid_date is empty / null / undefined
    const isDisabled = !dateValue;

    const statusStyles = {
      PAID: {
        backgroundColor: "#d1ecf1",
        color: "#0c5460",
        borderColor: "#bee5eb",
      },
      PENDING: {
        backgroundColor: "#e2d6f6",
        color: "#6f42c1",
        borderColor: "#c8b6e2",
      },
      REJECTED: {
        backgroundColor: "#f8d7da",
        color: "#a31616",
        borderColor: "#f5c6cb",
      },
    };

    const styles = statusStyles[statusValue] || {
      backgroundColor: "#fff",
      color: "#000",
      borderColor: "#ccc",
    };

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <FormControl size="small" sx={{ width: 130 }}>
          <Select
            value={statusValue}
            onChange={(e) => handleUpdateInlineStatus(e, row, dateValue)}
            input={<OutlinedInput />}
            disabled={isDisabled || login_user_role === "MANAGER"} // ✅ disable condition here
            sx={{
              fontWeight: 600,
              borderRadius: "8px",
              "& .MuiSelect-icon": {
                color: styles.color,
              },
              "&.Mui-disabled": {
                backgroundColor: "#f5f5f5", // optional: gray out disabled
                color: "#999",
              },
            }}
            componentsProps={{
              input: {
                sx: {
                  backgroundColor: styles.backgroundColor,
                  color: styles.color,
                  borderRadius: "8px",
                },
              },
            }}
          >
            {["PAID", "PENDING"].map((status) => (
              <MenuItem key={status} value={status}>
                {status.charAt(0) + status.slice(1).toLowerCase()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    );
  };

  const renderDateCell = (params) => {
    const row = params.row;
    const statusValue = row.payment_status;
    const dateValue = row.paid_date;

    const handleOpenCalendar = (event, rowId) => {
      setDateAnchorEl({ anchorEl: event.currentTarget, rowId });
    };
    const statusStyles = {
      backgroundColor: "rgb(193, 232, 241)",
      color: "var(--text-color)",
      borderColor: "rgb(73, 137, 248)",
    };
    const handleCloseCalendar = () => {
      setDateAnchorEl({ anchorEl: null, rowId: null });
    };

    const handleDateChange = (newDate, row) => {
      console.log("date new", newDate);

      handleUpdateInlineDate(newDate, row, statusValue);
      // console.log("Selected Date:", newDate, "Row:", row);
      handleCloseCalendar();
    };

    const open = Boolean(anchorDateEl);

    return (
      <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
        <FormControl>
          <TextField
            value={dateValue || "YYYY-MM-DD"}
            onClick={(e) => {
              if (login_user_role !== "MANAGER") {
                handleOpenCalendar(e, row?.user_id);
              }
            }}
            disabled={login_user_role === "MANAGER"}
            InputProps={{ readOnly: true }}
            sx={{
              width: "85%",
              backgroundColor: "rgb(193, 232, 241)",
              borderRadius: "8px",
              "& .MuiInputBase-input": { fontWeight: 400, padding: "8px 12px" },
              textAlign: "center",
            }}
          />
        </FormControl>

        <Popover
          open={
            login_user_role !== "MANAGER" &&
            anchorDateEl?.rowId === row?.user_id
          }
          anchorEl={anchorDateEl.anchorEl}
          onClose={handleCloseCalendar}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <OTReportCalender
            selectionRange={{
              startDate: dateValue ? new Date(dateValue) : new Date(),
              endDate: dateValue ? new Date(dateValue) : new Date(),
              key: "selection",
            }}
            maxDate={new Date()} // ⛔ Disable future dates
            setSelectionRange={(range) => {
              const dateStr = range.startDate.toISOString().split("T")[0];
              console.log("🟢 Selected Date:", dateStr);
              handleDateChange(dateStr, row);
            }}
            onClose={handleCloseCalendar}
          />
        </Popover>
      </Box>
    );
  };

  const handleInfoClick = (row) => {
    // console.log("row_information :", row);

    setSelectedRow(row);
    setInfoPanelOpen(true);
  };

  const handleClosePanel = () => {
    setInfoPanelOpen(false);
    setSelectedRow(null);
  };

  const { control } = useForm();
  const handleCheckboxChange = (rowId, userId) => {
    // console.log("checkbox_rows ids:", rowId, userId);
    const newCheckedRows = { ...checkedRows };
    newCheckedRows[rowId] = !newCheckedRows[rowId];

    if (newCheckedRows[rowId]) {
      setSelectedUserIds((prev) => [...prev, userId]);
    } else {
      setSelectedUserIds((prev) => prev.filter((id) => id !== userId));
    }

    const allChecked = collectionOfDatas.every(
      (row) => newCheckedRows[row?.user_id]
    );
    setIsAllSelected(allChecked);

    setCheckedRows(newCheckedRows);
  };
  // console.log("checkbox_rows collectionOfDatas:", collectionOfDatas);
  const handleSelectAll = () => {
    const newCheckedState = !isAllSelected;
    const newCheckedRows = {};

    if (newCheckedState) {
      collectionOfDatas.forEach((row) => {
        newCheckedRows[row?.user_id] = true;
      });
      setSelectedUserIds(collectionOfDatas.map((row) => row.user_id));
    } else {
      setSelectedUserIds([]);
    }

    setCheckedRows(newCheckedRows);
    setIsAllSelected(newCheckedState);
  };

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 210,
      renderHeader: () => (
        <Box display="flex" alignItems="center" gap={1}>
          <Checkbox checked={isAllSelected} onChange={handleSelectAll} />
          Select All
          <IconButton
            disabled={
              selectedUserIds.length === 0 || login_user_role === "MANAGER"
            }
            onClick={() => {
              setSelectedStatus("PENDING");
              setPaidDate(null);
              setStatusModalOpen(true);
            }}
          >
            <MoreVertIcon />
          </IconButton>
        </Box>
      ),
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <Checkbox
              checked={!!checkedRows[row?.user_id]}
              onChange={() => handleCheckboxChange(row?.user_id, row.user_id)}
            />
          </Box>
        );
      },
    },
    {
      field: "user_name",
      headerName: `Staff Names (${usersCount})`,
      width: 250,
      renderCell: (params) => {
        const { row } = params;
        // console.log("log_details :", row?.approved_log_details);

        return (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="flex-start"
            height="100%"
            onClick={() => handleUserClick(row)}
          >
            <Typography fontWeight={500} sx={{ textDecoration: "underline" }}>
              {row.user_name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {row.department_name}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "pending_hours",
      headerName: "Pending Hours",
      width: 120,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <Typography
              onClick={() => handleInfoClick(row)}
              className="pending-hours-text"

              // sx={{ color: isDarkMode?  "var(--bench-text) !important" : "var(--bench-text) !important" }}
            >
              {row.pending_hours}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "approved_hours",
      headerName: "Approved Hours",
      width: 120,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <Typography
              className="approved-hours-text"
              // sx={{ color: "var(--longterm-text) !important" }}
            >
              {row.approved_hours}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "per_hour_cost",
      headerName: "Per Hour Cost",
      width: 150,
      renderHeader: () => (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          height="100%"
        >
          <Typography className="text-center">Per Hour Cost</Typography>
          (without seat charge)
        </Box>
      ),
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <Typography>
              {row.per_hour_cost?.toLocaleString("en-IN")}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "approved_amount",
      headerName: "Cost",
      width: 120,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <Typography fontWeight={600}>
              {row.approved_amount?.toLocaleString("en-IN")}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "paid_date",
      headerName: "Paid Date",
      width: 180,
      renderCell: renderDateCell,
    },
    {
      field: "payment_status",
      headerName: "Payment Status",
      width: 200,
      renderCell: renderStatusCell,
    },

    {
      field: "notes",
      headerName: "Notes",
      width: 200,
      renderCell: (params) => {
        const row = params.row;
        const dateValue = row.paid_date;
        const isDisabled = login_user_role === "MANAGER" || !dateValue;

        return (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="100%"
            onClick={() => !isDisabled && handleNotesClick(row)}
            sx={{
              cursor: isDisabled ? "not-allowed" : "pointer",
              opacity: isDisabled ? 0.5 : 1, // 🔥 grey out
              pointerEvents: isDisabled ? "none" : "auto",
              disabled: login_user_role === "MANAGER",
            }}
          >
            <Typography
              variant="body2"
              noWrap
              sx={{
                textAlign: "center",
                width: "100%",
                color: "var(--text-color)",
              }}
            >
              {/* {typeof row?.notes === "string"
  ? row.notes.replace(/<[^>]+>/g, "")
  : "Add Notes"} */}
              {row?.notes ? row?.notes.replace(/<[^>]+>/g, "") : "Add Notes"}
            </Typography>
          </Box>
        );
      },
    },
  ];
  const stripHtml = (html = "") => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const detailColumns = [
    {
      field: "index",
      headerName: "ID",
      width: 80,
      align: "center",
      // headerAlign: "center",
      renderCell: (params) => {
        const { row } = params;
        return (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="flex-start"
            height="100%"
          >
            {row.index}
          </Box>
        );
      },
    },
    {
      field: "log_date",
      headerName: `Date`,
      width: 150,
      renderCell: (params) => {
        const { row } = params;
        return (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="flex-start"
            height="100%"
          >
            {row.log_date}
          </Box>
        );
      },
    },
    {
      field: "project_title",
      headerName: "Project Name",
      width: 220,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box display="flex" alignItems="center" height="100%">
            <Typography>{row.project_title || "-"}</Typography>
          </Box>
        );
      },
    },
    // {
    //   field: "user_name",
    //   headerName: "User Name",
    //   width: 220,
    //   renderCell: (params) => {
    //     const row = params.row;
    //     return (
    //       <Box display="flex" alignItems="center" height="100%">
    //         <Typography>{row.user_name}</Typography>
    //       </Box>
    //     );
    //   },
    // },
    {
      field: "task_title",
      headerName: "Task Title",
      width: 250,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box display="flex" alignItems="center" height="100%">
            <Typography>{row.task_title}</Typography>
          </Box>
        );
      },
    },
    {
      field: "start_time",
      headerName: "Hours",
      width: 200,

      renderCell: (params) => {
        const row = params.row;
        return (
          <Box display="flex" alignItems="center" height="100%">
            <Typography>{`${convertTo12HourFormat(
              row.start_time
            )}-${convertTo12HourFormat(row.end_time)}`}</Typography>
          </Box>
        );
      },
    },
    {
      field: "hours",
      headerName: "Total Hours",
      width: 150,

      renderCell: (params) => {
        const row = params.row;
        return (
          <Box display="flex" alignItems="center" height="100%">
            <Typography>{row.hours}</Typography>
          </Box>
        );
      },
      renderCell: (params) => {
        const { row } = params;

        if (row.isGroup) return null;

        const hours_in_decimal = row.hours_in_decimal ?? "0";
        const totalHours = row.hours ?? 0;

        return (
          <Box>
            {totalHours}{" "}
            <span style={{ color: "#777", fontSize: "12px" }}>
              ({hours_in_decimal} hrs)
            </span>
          </Box>
        );
      },
    },

    {
      field: "approved_status",
      headerName: "Payment Status",
      width: 200,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box display="flex" alignItems="center" height="100%">
            <Typography>{row.approved_status}</Typography>
          </Box>
        );
      },
    },
    {
      field: "approved_by",
      headerName: "Approved By",
      width: 200,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box display="flex" alignItems="center" height="100%">
            <Typography>{row.approved_by || "-"}</Typography>
          </Box>
        );
      },
    },

    {
      field: "notes",
      headerName: "Notes",
      width: 200,
      renderCell: (params) => {
        const row = params.row;
        const { notes } = row;
        if (!notes) return "-";
        const plainText = stripHtml(notes).replace(/\s+/g, " ").trim();

        const shortText =
          plainText.length > 20 ? `${plainText.slice(0, 20)}...` : plainText;

        return (
          <Tooltip
            title={<RichText tag="span" html={notes} />}
          >
            <Box
              display="flex"
              alignItems="center"
              width="100%"
              height="100%"
              sx={{
                cursor: "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {shortText}
            </Box>
          </Tooltip>
        );
      },
    },
  ];
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleExport = async () => {
    try {
      const requestedData = {
        department_id: selectedProjectId,
        month: selectedMonth,
        year: selectedYear,
        search: debouncedSearchTerm,
        isExport: 1,
      };
      const response = await filterEntities("ot/reports", requestedData);
      if (response) {
        toast.success(response.message);
        const file_url = response.data?.fileUrl;
        // const link = document.createElement("a");
        // link.href = file_url;
        // link.setAttribute("download", "");
        // document.body.appendChild(link);
        // link.click();
        // link.remove();
        const link = document.createElement("a");
        link.href = file_url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      handleCloseMenu();
    }
  };

  const updateApprovalStatus = async (rows, approvalStatus, date) => {
    // console.log("approvestatus date", date);

    const today = new Date();
    const selectedDate = new Date(date);

    // Only compare yyyy-mm-dd (ignore time)
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      toast.error("Future date can't be selected");
      return;
    }
    setLoading(true);

    const rowsArray = Array.isArray(rows) ? rows : [rows];

    const reports = rowsArray.map((row) => ({
      user_id: row?.user_id,
      payment_status: approvalStatus,
      // paid_date: approvalStatus === "PAID" ? date : row.paid_date,
      paid_date: date,
      approved_hours: row.approved_hours,
      notes: row.notes,
    }));

    const requestedData = {
      month: selectedMonth,
      year: selectedYear,
      reports: reports,
    };

    try {
      const response = await createEntity("ot/reports/update", requestedData);
      if (response) {
        toast.success(response.message);
        ot_data_refetch();
        setCheckedRows({});
        setSelectedUserIds([]);
        setIsAllSelected(false);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setStatusModalOpen(false);
      setLoading(false);
    }
  };

  const handleUpdateInlineStatus = (event, row, date) => {
    const value = event.target.value;
    setSelectedChildren(row?.user_id);
    setSelectedStatus(value);
    // reset date if status is not PAID
    if (value !== "PAID") {
      setPaidDate(null);
    }
    updateApprovalStatus(row, value, date);
  };

  const handleUpdateInlineDate = (date, row, statusValue) => {
    // console.log("inside function date",date);

    const new_date = dayjs(date).format("YYYY-MM-DD");
    console.log("newdate", new_date);

    setSelectedChildren(row?.user_id);
    updateApprovalStatus(row, statusValue, new_date);
  };
  const handleUpdateSheet = async () => {
    const selectedRowsData = collectionOfDatas.filter(
      (row) => checkedRows[row?.user_id]
    );
    await updateApprovalStatus(selectedRowsData, selectedStatus, paidDate);
  };

  return (
    <>
      {loading || ot_datas_loading ? (
        <Loader />
      ) : (
        <div style={{ padding: "16px" }} className="bg-white">
          <Box sx={{ width: "100%" }} className="bg-transparent">
            {/* <div className="d-flex justify-content-between align-items-center flex-nowrap  gap-3">
              <div className="d-flex align-items-center  gap-3"> */}

        {/* Box tag using for border box for header content page , Replaced dive tag to box tag  */}
          <Box  
            className="d-flex justify-content-between align-items-center flex-nowrap gap-3"
            sx={{
              border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
              borderRadius: "6px",
              padding: "12px 16px",
              marginBottom: "16px",
              backgroundColor: isDarkMode ? "transparent" : "#fff",
            }}
          >
            <div className="d-flex align-items-center gap-3">
              <FormControl size="small">
                <Controller
                  name="project_name"
                  control={control}
                  defaultValue={null}
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      fullWidth
                      size="small"
                      options={get_all_departments}
                      getOptionLabel={(option) =>
                        option?.department_name || ""
                      }
                      value={
                        get_all_departments.find(
                          (p) => p.department_id === value?.department_id
                        ) || null
                      }
                      onChange={(e, newValue) => {
                        onChange(newValue);
                        setSelectedProjectId(newValue?.department_id || 0);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.department_id === value?.department_id
                      }
                      renderOption={(props, option, { selected }) => (
                        <li
                          {...props}
                          className="d-flex align-items-center mb-2"
                        >
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          <strong>{option.department_name}</strong>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select domain"
                          variant="outlined"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "5px",
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,

                            sx: {
                              fontWeight: 500,
                              fontSize: 13,
                              borderRadius: "5px",
                              width: "200px",
                              padding: "6px 12px",
                              height: 36,
                            },
                          }}
                        />
                      )}
                      sx={{ width: "100%" }}
                    />
                  )}
                />
              </FormControl>
              <Select
                size="small"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(Number(e.target.value))}
                sx={{ borderRadius: "5px" }}
              >
                {months.map((month, index) => (
                  <MenuItem key={index} value={index + 1}>
                    {month}
                  </MenuItem>
                ))}
              </Select>

              <Select
                size="small"
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
                sx={{ borderRadius: "5px" }}
              >
                {getLast7Years().map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div
              className="d-flex align-items-center justify-content-center gap-3"
                // style={{ minWidth: 300 }}
            >
                <div className=" total_payable  ">
                  <p className="mb-0"> OT Payable</p>
                <h2>₹ {ot_datas?.total_payable?.toLocaleString("en-IN")}</h2>
              </div>

                <div className="  total_netpaid ">
                  <p className="mb-0"> OT Paid</p>
                <h2>₹ {ot_datas?.total_paid?.toLocaleString("en-IN")}</h2>
              </div>
            </div>

              <div className="d-flex align-items-center gap-3 flex-nowrap">
              <SearchBar
                placeholder="Search user"
                searchTerm={searchTerm}
                onSearchChange={handleSearchChange}
              />

              <Tooltip title="Export">
                <IconButton
                  className="d-flex align-items-center justify-content-center"
                  sx={{
                    backgroundColor: isDarkMode
                      ? "rgba(67, 105, 255, 0.08)"
                      : "#F1F5FF",
                    borderRadius: "50%",
                    width: "36px",
                    height: "36px",
                    "&:hover": {
                      backgroundColor: "var(--icon-hover-bg)",
                    },
                  }}
                  onClick={handleMenuOpen}
                >
                    <SlOptions size={20} className="text-rgbr-blue " />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleCloseMenu}
                PaperProps={{ sx: { borderRadius: "8px" } }}
              >
                <MenuItem
                  onClick={handleExport}
                  disabled={login_user_role === "MANAGER"}
                >
                  Export
                </MenuItem>
              </Menu>
            </div>
            {/* </div> */}
            </Box>
          </Box>
          <div className="my-3">
            <DataGrid
              columns={columns}
              rows={collectionOfDatas}
              getRowId={(row) => row?.user_id}
              loading={loading || ot_datas_loading}
              onRowClick={(params) => console.log("row_record", params?.row)}
              rowHeight={60}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              hideFooterSelectedRowCount
            />
          </div>
          <Offcanvas
            show={infoPanelOpen}
            onHide={handleClosePanel}
            placement="end"
            style={{ width: "30%" }}
          >
            <Offcanvas.Body>
              <OTReportsDetail
                selectedRow={selectedRow}
                handleClosePanel={handleClosePanel}
              />
            </Offcanvas.Body>
          </Offcanvas>

          <Dialog
            open={statusModalOpen}
            onClose={() => setStatusModalOpen(false)}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DialogContent sx={{ minWidth: 400 }}>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                  <Box display="flex" alignItems="center" gap={4}>
                    <Typography sx={{ minWidth: 120 }}>
                      Payment Status
                    </Typography>

                    <FormControl size="small" sx={{ width: 150 }}>
                      <Select
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                        size="small"
                        sx={{
                          fontWeight: 600,
                          borderRadius: "6px",
                          "& .MuiSelect-icon": {
                            color: getStatusStyle(selectedStatus).color,
                          },
                        }}
                        componentsProps={{
                          input: {
                            sx: {
                              backgroundColor:
                                getStatusStyle(selectedStatus).backgroundColor,
                              color: getStatusStyle(selectedStatus).color,
                              borderRadius: "8px",
                            },
                          },
                        }}
                      >
                        {["PAID", "PENDING"].map((status) => (
                          <MenuItem key={status} value={status}>
                            {status === "PAID" ? "Paid" : "Pending"}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  {selectedStatus === "PAID" && (
                    <Box display="flex" alignItems="center" gap={4}>
                      <Typography sx={{ minWidth: 120 }}>Paid Date</Typography>

                      <FormControl size="small" sx={{ width: 150 }}>
                        <Controller
                          name="paid_date"
                          control={control}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              format="DD/MM/YYYY"
                              onChange={(date) => {
                                field.onChange(date);
                                setPaidDate(dayjs(date).format("YYYY-MM-DD"));
                              }}
                              value={paidDate ? dayjs(paidDate) : null}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  fullWidth
                                  sx={{
                                    borderRadius: "8px",
                                    "& .MuiInputBase-root": {
                                      height: 40,
                                      boxSizing: "border-box",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontWeight: 400,
                                      padding: "8px 12px",
                                    },
                                  }}
                                />
                              )}
                            />
                          )}
                        />
                      </FormControl>
                    </Box>
                  )}

                  <Typography>
                    Are you sure want to change the payment status for selected
                    user?
                  </Typography>
                </Box>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => setStatusModalOpen(false)}
                  sx={{ color: "#999" }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#28a745",
                    "&:hover": { backgroundColor: "#218838" },
                  }}
                  onClick={handleUpdateSheet}
                >
                  Save
                </Button>
              </DialogActions>
            </LocalizationProvider>
          </Dialog>
          <Modal open={noteModalOpen} onClose={() => setNoteModalOpen(false)}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "var(--cell-bg-color)",
                p: 3,
                borderRadius: 2,
                width: 400,
              }}
            >
              <Typography variant="h6" gutterBottom>
                Edit Notes
              </Typography>

              <TextField
                fullWidth
                multiline
                rows={4}
                value={noteText}
                onChange={(e) => setNoteText(e.target.value)}
              />

              <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
                <button
                  className="cancel_btn"
                  onClick={() => setNoteModalOpen(false)}
                >
                  Cancel
                </button>
                <button className=" add_btn" onClick={handleSaveNote}>
                  Save
                </button>
              </Box>
            </Box>
          </Modal>
        </div>
      )}
      <Dialog
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            width: "80%",
            maxWidth: "80%",
          },
        }}
        open={open}
        onClose={handleToggleOpen}
      >
        <div className=" d-flex align-items-center justify-content-between mx-4 ">
          <DialogTitle>{`${
            filter === "approved_hours" ? "Approved" : "Pending"
          } Log Details`}</DialogTitle>
          <FormControl className="pb-2 ">
            <Select value={filter} onChange={handleFilterChange}>
              {filterOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="p-3">
          <DataGrid
            columns={detailColumns}
            rows={staffDetails}
            getRowId={(row) => row?.id}
            loading={loading || ot_datas_loading}
            rowHeight={60}
            pagination
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModal}
            pageSizeOptions={[25, 50, 75, 100]}
            disableColumnMenu
            disableColumnSorting
            disableColumnFilter
            disableColumnSelector
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            hideFooterSelectedRowCount
          />
        </div>
      </Dialog>
    </>
  );
};

export default OTRepotrs;
